(function($) {
	$(function() {
	});
})(jQuery);